import { render } from "./SearchItemBoolean.vue?vue&type=template&id=9c9ce1f8"
import script from "./SearchItemBoolean.vue?vue&type=script&lang=ts"
export * from "./SearchItemBoolean.vue?vue&type=script&lang=ts"
script.render = render

export default script